import { Layout, Segment, Row, Col } from 'tea-component';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import CardLoading from '@/pages/opinion/components/CardLoading';
import GameRankingList from '../GameRankingList';
import HotContent from '../HotContent';
import React, { useMemo, useState } from 'react';
import ChannelLabel, { ChannelIconType } from '@op/components/ChannelLabel';
import { useIntl } from 'umi';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { DBO_TM } from '@op/utils/format';

export default function MainContent({
  gameInfo,
  params,
  filterParams,
  tab,
}: {
  gameInfo: any;
  params: any;
  filterParams: Array<'pc' | 'mobile' | 'console'>;
  tab: string;
}) {
  const {
    loading,
    filter: oriFilter,
    changeFilter,
    filterOptions,
    filterCommonParams,
  } = useFilterDataHook({
    pageName: 'Channel_Share_Rankings',
  });
  const { formatMessage } = useIntl();
  const [channel, setChannel] = useState('total');
  const [selectedGameInfo, setSelectedGameInfo] = useState(null);
  const [showHotContent, setShowHotContent] = useState(false);

  function changeGameInfo(gameInfo: any) {
    setSelectedGameInfo(gameInfo);
    setShowHotContent(true);
  }

  function onClear() {
    setShowHotContent(false);
    setSelectedGameInfo(null);
  }

  const channelShareTab: () => {
    text: string | any;
    value: any;
  }[] = () => {
    const tab: { text?: string; value: ChannelIconType | 'total' }[] = [
      { text: 'Total', value: 'total' },
      { value: 'youtube' },
      { value: 'tiktok' },
      { value: 'instagram' },
      { value: 'facebook' },
      { value: 'twitter' },
    ];
    return tab.map((item) => {
      return {
        text: (
          <div className="dbo-inlineflex">
            {item.text ? (
              <span>{formatMessage({ id: item.text })}</span>
            ) : (
              <ChannelLabel
                iconStyle={{ width: 16, height: 16, marginRight: 4 }}
                channel_name={item.value as ChannelIconType}
              ></ChannelLabel>
            )}
          </div>
        ),
        value: item.value,
      };
    });
  };

  const { filter, hotContentFilter } = useMemo(() => {
    let channels: Array<string> = [];
    if (channel !== 'total') {
      channels = [channel];
    }
    const filter = {
      ...oriFilter,
      channels,
    };
    return {
      filter,
      hotContentFilter: {
        ...filter,
        social_media_by_account: ['-99999'],
        social_media_by_keyword: ['-99999'],
        external_data_sources: ['LevelUp'],
      },
    };
  }, [oriFilter, channel]);

  return (
    <>
      <FilterFixed
        filter={filterOptions}
        operateShowOptions={null}
        isTile
        {...filterCommonParams}
        defaultConfig={{
          date: { showTimeTips: false },
          levelUpGame: {
            params: filterParams,
          },
        }}
        defaultValue={DBO_TM.utcFilterRangeDay(1, 1)}
        confirm={(value) => {
          onClear();
          changeFilter({ ...value, ...gameInfo, ...params });
        }}
      ></FilterFixed>

      <CardLoading loading={loading}>
        <Segment
          className="segment-light segment-font12"
          value={channel}
          onChange={(value) => {
            onClear();
            setChannel(value);
            buriedBtnPoint('SwitchChannelType', { channel: value });
          }}
          options={channelShareTab()}
        />
        <div className="dbo-channel-share-ranking-row">
          <div className="dbo-channel-share-ranking-row-left">
            <GameRankingList
              filter={filter}
              tab={tab}
              selectedGameInfo={selectedGameInfo}
              changeGameInfo={changeGameInfo}
            ></GameRankingList>
          </div>
          <div
            className={`dbo-channel-share-ranking-row-right ${
              showHotContent ? '--show' : ''
            }`}
          >
            <HotContent
              onClear={onClear}
              selectedGameInfo={selectedGameInfo}
              filter={hotContentFilter}
            ></HotContent>
          </div>
        </div>
      </CardLoading>
    </>
  );
}
